var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"kp-card feature-card"},[_c('picture',[_c('img',{attrs:{"src":require(("@/assets/" + (_vm.props.imgSrc))),"alt":""}})]),_c('h3',[_vm._t("title")],2),_c('p',[_vm._t("description")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }